"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFuturesTPSLProcessor = void 0;
const SimpleFuturesAPI_1 = require("../../../apis/SimpleFuturesAPI");
const interface_1 = require("../../../interface");
const trade_utils_lib_1 = require("trade_utils_lib");
const errors_1 = require("../../../interface/errors");
const react_1 = require("react");
const context_1 = require("../../../context");
const utils_1 = require("../utils");
var SimpleFuturesTPSLProcessor;
(function (SimpleFuturesTPSLProcessor) {
    // 获取止盈止损的设置状态
    SimpleFuturesTPSLProcessor.useTPSLState = (tpslParams, TPSLLimit) => {
        return (0, react_1.useMemo)(() => {
            var _a, _b, _c, _d;
            let tpState = interface_1.SimpleFutures.TPSLStateEnum.not_set;
            let slState = interface_1.SimpleFutures.TPSLStateEnum.not_set;
            if (!(tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.mode)) {
                return {
                    tp: tpState,
                    sl: slState,
                };
            }
            switch (tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.mode) {
                // 默认按收益率
                default: {
                    if (tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.data.profit_rate) {
                        const tp = new trade_utils_lib_1.SafeDecimal(tpslParams.data.profit_rate);
                        tpState = interface_1.SimpleFutures.TPSLStateEnum.normal;
                        if (TPSLLimit === null || TPSLLimit === void 0 ? void 0 : TPSLLimit.tp) {
                            if (((_a = TPSLLimit.tp) === null || _a === void 0 ? void 0 : _a.max) && tp.greaterThan(TPSLLimit.tp.max)) {
                                // 止盈大了
                                tpState = interface_1.SimpleFutures.TPSLStateEnum.too_high;
                            }
                            else if (((_b = TPSLLimit.tp) === null || _b === void 0 ? void 0 : _b.min) && tp.lessThan(TPSLLimit.tp.min)) {
                                // 止盈小了
                                tpState = interface_1.SimpleFutures.TPSLStateEnum.too_low;
                            }
                        }
                    }
                    if (tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.data.loss_rate) {
                        const sl = new trade_utils_lib_1.SafeDecimal(tpslParams.data.loss_rate);
                        slState = interface_1.SimpleFutures.TPSLStateEnum.normal;
                        if (TPSLLimit === null || TPSLLimit === void 0 ? void 0 : TPSLLimit.sl) {
                            if (((_c = TPSLLimit.sl) === null || _c === void 0 ? void 0 : _c.max) && sl.greaterThan(TPSLLimit.sl.max)) {
                                // 止损大了
                                slState = interface_1.SimpleFutures.TPSLStateEnum.too_high;
                            }
                            else if (((_d = TPSLLimit.sl) === null || _d === void 0 ? void 0 : _d.min) && sl.lessThan(TPSLLimit.sl.min)) {
                                // 止损小了
                                slState = interface_1.SimpleFutures.TPSLStateEnum.too_low;
                            }
                        }
                    }
                }
            }
            return {
                tp: tpState,
                sl: slState,
            };
        }, [TPSLLimit === null || TPSLLimit === void 0 ? void 0 : TPSLLimit.sl, TPSLLimit === null || TPSLLimit === void 0 ? void 0 : TPSLLimit.tp, tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.data.loss_rate, tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.data.profit_rate, tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.mode]);
    };
    // 检查止盈止损是否合规
    SimpleFuturesTPSLProcessor.checkTPSLStateError = (state, limit) => {
        var _a, _b, _c, _d;
        const parseDecimal = (v) => {
            var _a;
            return ((_a = v === null || v === void 0 ? void 0 : v.mul(100).toFixed(2)) !== null && _a !== void 0 ? _a : "--") + "%";
        };
        if (state.tp === interface_1.SimpleFutures.TPSLStateEnum.too_high) {
            return (0, errors_1.cloneError)(errors_1.TRADE_TP_RATE_TOO_HIGH, { value: parseDecimal((_a = limit === null || limit === void 0 ? void 0 : limit.tp) === null || _a === void 0 ? void 0 : _a.max) });
        }
        else if (state.tp === interface_1.SimpleFutures.TPSLStateEnum.too_low) {
            return (0, errors_1.cloneError)(errors_1.TRADE_TP_RATE_TOO_LOW, { value: parseDecimal((_b = limit === null || limit === void 0 ? void 0 : limit.tp) === null || _b === void 0 ? void 0 : _b.min) });
        }
        if (state.sl === interface_1.SimpleFutures.TPSLStateEnum.too_high) {
            return (0, errors_1.cloneError)(errors_1.TRADE_SL_RATE_TOO_HIGH, { value: parseDecimal((_c = limit === null || limit === void 0 ? void 0 : limit.sl) === null || _c === void 0 ? void 0 : _c.max) });
        }
        else if (state.sl === interface_1.SimpleFutures.TPSLStateEnum.too_low) {
            return (0, errors_1.cloneError)(errors_1.TRADE_SL_RATE_TOO_LOW, { value: parseDecimal((_d = limit === null || limit === void 0 ? void 0 : limit.sl) === null || _d === void 0 ? void 0 : _d.min) });
        }
    };
    /** 止盈止损限制 */
    function useTPSLLimit(params) {
        const { feeRate, mode, leverage, order, isActive = true } = params;
        const isCreateOrder = !order;
        const ticker = (0, context_1.useFuturesTickerParseContext)({ base: order === null || order === void 0 ? void 0 : order.base, quote: order === null || order === void 0 ? void 0 : order.quote, isFocused: !isCreateOrder && isActive });
        const [, totalProftRate] = (0, react_1.useMemo)(() => {
            if (isCreateOrder) {
                const zero = new trade_utils_lib_1.SafeDecimal(0);
                return [zero, zero];
            }
            const profit = utils_1.SimpleFuturesUtils.getTotalProfit(order, ticker === null || ticker === void 0 ? void 0 : ticker.latest);
            const profitRate = profit.div(new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.quote_invest));
            return [profit, profitRate];
        }, [isCreateOrder, order, ticker === null || ticker === void 0 ? void 0 : ticker.latest]);
        return (0, react_1.useMemo)(() => {
            const leverageD = new trade_utils_lib_1.SafeDecimal(leverage);
            const takerFee = new trade_utils_lib_1.SafeDecimal(feeRate.takerFeeRate);
            switch (mode) {
                // 默认按收益率
                default: {
                    const tp = {
                        //最小值（含）：当前收益率+0.1%*杠杆倍数
                        min: leverageD.mul(0.001).add(totalProftRate),
                        //最大值（含）：100000
                        max: new trade_utils_lib_1.SafeDecimal(1000),
                    };
                    let sl;
                    if (isCreateOrder) {
                        sl = {
                            //最小值（含）：2*用户taker手续费率*杠杆倍数+0.1%*杠杆倍数
                            max: takerFee.mul(2).mul(leverageD).add(leverageD.mul(0.001)).mul(-1),
                            // 先默认0.8，后续会考虑强平价
                            min: new trade_utils_lib_1.SafeDecimal(-0.8),
                        };
                    }
                    else {
                        sl = {
                            //最大值（含）：当前收益率-1*(用户taker手续费率+0.1%)*杠杆倍数
                            max: totalProftRate.sub(leverageD.mul(takerFee.add(0.001))),
                            // 先默认0.8，后续会考虑强平价
                            min: new trade_utils_lib_1.SafeDecimal(-0.8),
                        };
                    }
                    return {
                        mode: mode,
                        tp: tp,
                        sl: sl,
                    };
                }
            }
        }, [feeRate.takerFeeRate, isCreateOrder, leverage, mode, totalProftRate]);
    }
    SimpleFuturesTPSLProcessor.useTPSLLimit = useTPSLLimit;
    SimpleFuturesTPSLProcessor.editOrderTPSL = (props) => {
        const { newParams, order } = props;
        return SimpleFuturesAPI_1.SimpleFuturesAPI.editTPSL({
            orderId: order.bu_order_id,
            tpsl: newParams,
        });
    };
})(SimpleFuturesTPSLProcessor = exports.SimpleFuturesTPSLProcessor || (exports.SimpleFuturesTPSLProcessor = {}));
